import React from 'react';
import { motion } from 'framer-motion';
import { FaChevronRight, FaStar, FaClock } from 'react-icons/fa';
import { useNavigate } from 'react-router-dom';
import './TourPackages.css'; // Name updated to match

const TourPackages = () => {
  const navigate = useNavigate();

  const packages = [
    { id: 1, slug: "sikkim-darjeeling-escape", name: "Sikkim Darjeeling", days: "6N/7D", img: "https://s3.ap-south-1.amazonaws.com/awsimages.imagesbazaar.com/1200x1800-old/17832/BX790482.jpg?date=Thu%20Mar%2012%202026%2011:03:20%20GMT+0530%20(India%20Standard%20Time)" },
    { id: 2, slug: "jagannath-puri-divine-darshan", name: "Jagannath Puri", days: "6N/7D", img: "https://images.unsplash.com/photo-1706790574525-d218c4c52b5c?q=80&w=1170&auto=format&fit=crop&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D" },
    { id: 3, slug: "mathura-vrindavan-divine-yatra", name: "Mathura Vrindavan", days: "4N/5D", img: "https://s3.ap-south-1.amazonaws.com/awsimages.imagesbazaar.com/1200x1800-old/1098/SR32023.jpg?date=Thu%20Mar%2012%202026%2011:56:40%20GMT+0530%20(India%20Standard%20Time)" },
    { id: 4, slug: "spiti-himalayan-adventure", name: "Spiti Adventure", days: "6N/7D", img: "https://s3.ap-south-1.amazonaws.com/awsimages.imagesbazaar.com/1200x1800-old/11492/CG341233.jpg" },
    { id: 5, slug: "shimla-manali-himalayan-escape", name: "Shimla Manali Escape", days: "5N/6D", img: "https://images.unsplash.com/photo-1712388430474-ace0c16051e2?q=80&w=1074&auto=format&fit=crop&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D" },
    { id: 6, slug: "andaman-island-paradise-tour", name: "Andaman Island Paradise", days: "7N/8D", img: "https://plus.unsplash.com/premium_photo-1661940254003-c3f37e5d32ad?q=80&w=1170&auto=format&fit=crop&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D" },
    { id: 7, slug: "kashmir-timeless-escape", name: "Kashmir Timeless Escape", days: "6N/7D", img: "https://images.unsplash.com/photo-1593417376544-4c4201061e22?q=80&w=1025&auto=format&fit=crop&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D" },
    { id: 8, slug: "mystical-meghalaya-tour", name: "Mystical Meghalaya", days: "6N/7D", img: "https://s3.ap-south-1.amazonaws.com/awsimages.imagesbazaar.com/1200x1800-old/17528/GP776940.jpg?date=Thu%20Mar%2012%202026%2014:47:42%20GMT+0530%20(India%20Standard%20Time)" },
    { id: 9, slug: "sacred-royal-rajasthan", name: "Sacred Royal Rajasthan", days: "6N/7D", img: "https://www.holidaymonk.com/wp-content/uploads/2024/09/Royal-Rajasthan-Experience-Tour-Package-1.webp" },
    { id: 10, slug: "kashi-ayodhya", name: "Kashi Ayodhya", price: "16,800", img: "https://www.mathuravrindavantaxiservices.com/tour/5-days-in-kashi-ayodhya.webp" },
    { id: 11, slug: "leh-ladakh-himalayan", name: "LehLadakh Himalayan", days: "6N/7D", img: "https://images.unsplash.com/photo-1581793745862-99fde7fa73d2?q=80&w=870&auto=format&fit=crop&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D" }
  ];

  const revealUp = {
    hidden: { opacity: 0, y: 80 },
    visible: { 
      opacity: 1, 
      y: 0, 
      transition: { duration: 0.8, ease: [0.22, 1, 0.36, 1] } 
    }
  };

  return (
    <section className="tp-section" id="tour-packages">
      <div className="tp-container">
        <div className="tp-header-premium">
          <motion.span 
            initial="hidden"
            whileInView="visible"
            viewport={{ once: false, amount: 0.5 }}
            variants={{
                hidden: { opacity: 0, letterSpacing: "0px" },
                visible: { opacity: 1, letterSpacing: "5px" }
            }}
            className="tp-top-label"
          >
            EXPLORE THE WORLD
          </motion.span>
          
          <motion.h2 
            initial="hidden"
            whileInView="visible"
            viewport={{ once: false, amount: 0.5 }}
            variants={revealUp}
            className="tp-main-title"
          >
            Domestic <span>Tour</span> Packages
          </motion.h2>



          <motion.div 
            initial={{ width: 0 }} 
            whileInView={{ width: "80px" }} 
            viewport={{ once: false }}
            transition={{ duration: 0.8 }}
            className="tp-line-center"
          ></motion.div>
        </div>

        <div className="tp-grid">
          {packages.map((pkg, idx) => (
            <motion.div 
              className="tp-premium-card" 
              key={pkg.id}
              variants={revealUp}
              initial="hidden"
              whileInView="visible"
              viewport={{ once: false, amount: 0.2 }}
              transition={{ delay: (idx % 4) * 0.1 }}
              onClick={() => navigate(`/${pkg.slug}`)} 
              style={{ cursor: 'pointer' }}
            >
              <div className="tp-card-img-box">
                <img src={pkg.img} alt={pkg.name} />
                <div className="tp-card-overlay">
                   <div className="tp-rating-tag"><FaStar /> 5.0</div>
                   <div className="tp-days-tag"><FaClock /> {pkg.days}</div>
                </div>
              </div>

              <div className="tp-card-info">
                <span className="tp-category">{pkg.type}</span>
                <h3>{pkg.name}</h3>
                <div className="tp-price-section">
                  <div className="tp-price-box">
                    {/* <span>Starting from</span>
                    <h4>₹{pkg.price}</h4> */}
                  </div>
                  <div className="tp-circle-btn">
                    <FaChevronRight />
                  </div>
                </div>
              </div>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default TourPackages;